<template>
  <v-dialog v-model="dialog" width="800px" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title class="primary white--text"
        ><v-toolbar-title>NHẬP EXCEL HOÀN TRẢ</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-card-text>
        <div
          class="d-flex flex-column justify-center align-center mx-auto"
          style="width: 330px; min-height: 320px"
          v-if="step === 'import'"
        >
          <v-img max-width="100px" max-height="100px" contain src="@/assets/upload-file.svg"></v-img>
          <div class="text-center content-text mt-5" @click="exportExcelTemplate">
            Tải tệp Excel (.xlsx) chứa thông tin hoàn trả
          </div>
          <div class="mt-5">
            <v-btn color="primary" class="mr-5" @click="exportExcelTemplate" outlined>Tải mẫu nhập</v-btn>
            <v-btn color="primary" class="elevation-0 white--text" :loading="isSelecting" @click="onExcelUpload">
              <span class="white--text">Chọn tệp</span>
              <input
                ref="uploader"
                type="file"
                class="d-none"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                @change="onFileChanged"
              />
            </v-btn>
          </div>
        </div>
        <div v-else>
          <div>
            <v-checkbox v-model="sendNoti" label="Gửi thông báo cho phụ huynh học sinh"></v-checkbox>
            <TableRefund :data="data" />
          </div>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between pa-4">
        <v-btn class="px-6" color="primary" outlined light depressed @click="cancel">Huỷ</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" width="100px" class="elevation-0" @click="confirm">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import readXlsxFile from 'read-excel-file'
import TableRefund from './TableRefund.vue'
import { TuitionFeeReport } from '@/plugins/api'
import { mapActions, mapGetters } from 'vuex'
const schema = {
  'Mã học sinh': {
    prop: 'studentCode',
    type: String,
  },
  'Ngân hàng': {
    prop: 'bankName',
    type: String,
  },
  'Số tài khoản': {
    prop: 'accountNumber',
    type: String,
  },
  'Tên tài khoản': {
    prop: 'accountName',
    type: String,
  },
  'Số tiền': {
    prop: 'amountMoney',
    type: Number,
  },
}
export default {
  components: { TableRefund },
  data() {
    return {
      dialog: false,
      step: 'import',
      isSelecting: false,
      sendNoti: false,
      selectedFile: null,
      data: [],
    }
  },
  computed: {
    ...mapGetters({
      detailPeriod: 'tuitionFeePeriod/detailPeriod',
    }),
  },
  methods: {
    ...mapActions({
      upload: 'upload/upload',
    }),
    openDialog() {
      this.step = 'import'
      this.data = []
      this.dialog = true
    },
    cancel() {
      this.$emit('cancel')
      this.dialog = false
    },
    async confirm() {
      try {
        this.$loading.active = true
        let formData = new FormData()
        formData.append('files', this.selectedFile)
        formData.append('source', 's3')
        formData.append('field', 'file')
        const url = await this.upload(formData)
        await TuitionFeeReport.refundFee({
          period: this.detailPeriod._id,
          data: this.data,
          sendNoti: this.sendNoti,
          urlFile: url,
        })
        this.$alert.success('Up File hoàn trả thành công')
        this.dialog = false
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    },
    exportExcelTemplate() {
      this.$loading.active = true
      window.location.href = `${window.location.origin}/Hoàn trả tiền thừa học phí.xlsx`
      this.$loading.active = false
    },
    onExcelUpload() {
      this.isSelecting = true
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false
        },
        { once: true }
      )
      this.$refs.uploader.click()
    },
    async onFileChanged(e) {
      this.$loading.active = true
      this.selectedFile = e.target.files[0]
      let readFileResult
      try {
        readFileResult = await readXlsxFile(this.selectedFile, {
          schema,
        })
      } catch (error) {
        this.$alert.error({
          title: 'File không có định dạng.',
          description: 'xlsx hoặc có dữ liệu không hợp lệ (tham khảo mẫu file)',
        })
        this.$loading.active = false
        return
      }
      if (readFileResult.errors.length !== 0) {
        const error = readFileResult.errors[0]
        this.$alert.error(`Lỗi Dòng ${error.row} - Cột ${error.column} - ${error.value}: ${error.error}`)
        this.$loading.active = false
        return
      } else {
        const results = readFileResult.rows
        this.data = results
        this.step = 'send'
      }
      this.$loading.active = false
    },
  },
}
</script>

<style></style>
